module.exports = __webpack_public_path__ + "static/media/Skeleton Guy.c8f45521.jpg";